import { Calendar } from '../../../models/calendar.model';

export const WEEKENDSDAYS_FIELDS = {
    'Fri': Calendar.V_FRIDAY,
    'Mon': Calendar.V_MONDAY,
    'Sat': Calendar.V_SATURDAY,
    'Sun': Calendar.V_SUNDAY,
    'Thu': Calendar.V_THURSDAY,
    'Tue': Calendar.V_TUESDAY,
    'Wed': Calendar.V_WEDNESDAY,
};
